import { annotationEvents } from "../constants.js";
import { tracker } from "../view-models/app-signals.js";
import { bookStore } from "./Store.js";

const LAST_READING_POSITION = "last-reading-position";
const BOOKMARKS = "bookmarks";

function getBookmarksArray() {
  const savedBookmarks = bookStore.getKeySync(BOOKMARKS);
  if (savedBookmarks) {
    return JSON.parse(savedBookmarks);
  } else {
    return [];
  }
}

export function getLastReadingPosition() {
  const positionString = bookStore.getKeySync(LAST_READING_POSITION);
  if (positionString) {
    return JSON.parse(positionString);
  }
  return null;
}

export function saveLastReadingPosition(position) {
  const positionString = JSON.stringify(position);
  bookStore.setKeySync(LAST_READING_POSITION, positionString);
  const trackerService = tracker();
  if (trackerService) {
    trackerService.handleAnnotations(
      annotationEvents.BookmarkCreated,
      position.id,
    );
  }
}

export function resetReadingPosition() {
  bookStore.removeKeySync(LAST_READING_POSITION);
}

export function initBookmarks(list) {
  if (typeof list === "string") {
    const savedBookmarksObj = JSON.parse(list);
    bookStore.setKeySync(BOOKMARKS, list);
    return savedBookmarksObj;
  } else {
    bookStore.setKeySync(BOOKMARKS, JSON.stringify(list));
    return list;
  }
}

export function saveBookmark(bookmark) {
  const savedBookmarks = getBookmarksArray();
  savedBookmarks.push(bookmark);
  bookStore.setKeySync(BOOKMARKS, JSON.stringify(savedBookmarks));
}

export function deleteBookmark(bookmark) {
  const savedBookmarks = getBookmarksArray().filter(
    (el) => el.id !== bookmark.id,
  );
  bookStore.setKeySync(BOOKMARKS, JSON.stringify(savedBookmarks));
  const trackerService = tracker();
  if (trackerService) {
    trackerService.handleAnnotations(
      annotationEvents.BookmarkDeleted,
      bookmark.id,
    );
  }
}

export function getBookmarks(href) {
  const savedBookmarks = getBookmarksArray().sort(
    (n1, n2) => n1.locations.progression - n2.locations.progression,
  );
  if (href) {
    return savedBookmarks.filter((el) => el.href === href);
  }
  return savedBookmarks;
}

export function locatorExists(locator) {
  const savedBookmarks = getBookmarksArray();
  return savedBookmarks.some(
    (el) => el.href === locator.href && el.page === locator.page,
  );
}
